export { Aviso } from './aviso.component'
export { TipoDeAviso } from './tipo-de-aviso.enum'
export { default as AvisoContainer } from './aviso.container'
export * from './configuracao-de-aviso.config'
